import request from "@/utils/request";

export const getOffer = (id) => request.get(`/offers/${id}`);

export const getUsers = ({ id, params } = {}) =>
  request.get(`/offers/${id}/users`, {
    params,
  });

export const createOffer = (field) => request.post("/offers", field);

export const changeStatus = ({ id, field } = {}) =>
  request.post(`/offers/${id}/change-status`, field);

export const getUsersSql = (params) =>
  request.get(`/users-by-sql`, {
    params,
  });
